import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../aws/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL;

// Configuración estándar para informes: 5 min de caché y no re-consultar al enfocar ventana
const CONFIG_REPORTE = {
    staleTime: 1000 * 60 * 5, 
    refetchOnWindowFocus: false,
};

export const useGetDashboardKPIs = (filtros) => {
    const { getJwtToken } = useAuth();
    return useQuery({
        queryKey: ['informes_dashboard', filtros.desde, filtros.hasta],
        queryFn: async () => {
            const token = await getJwtToken();
            const params = new URLSearchParams(filtros).toString();
            const res = await fetch(`${API_BASE_URL}/v1-informes-dashboard?${params}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('Error en Dashboard');
            return res.json();
        },
        ...CONFIG_REPORTE
    });
};

export const useGetInformesVentas = (filtros) => {
    const { getJwtToken } = useAuth();
    return useQuery({
        queryKey: ['informes_ventas', filtros.desde, filtros.hasta],
        queryFn: async () => {
            const token = await getJwtToken();
            const params = new URLSearchParams(filtros).toString();
            const res = await fetch(`${API_BASE_URL}/v1-informes-ventas?${params}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('Error en Ventas');
            return res.json();
        },
        ...CONFIG_REPORTE
    });
};

export const useGetInformesGastos = (filtros) => {
    const { getJwtToken } = useAuth();
    return useQuery({
        queryKey: ['informes_gastos', filtros.desde, filtros.hasta],
        queryFn: async () => {
            const token = await getJwtToken();
            const params = new URLSearchParams(filtros).toString();
            const res = await fetch(`${API_BASE_URL}/v1-informes-gastos?${params}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('Error en Gastos');
            return res.json();
        },
        ...CONFIG_REPORTE
    });
};

export const useGetInformesCaja = (filtros) => {
    const { getJwtToken } = useAuth();
    return useQuery({
        queryKey: ['informes_caja', filtros.desde, filtros.hasta],
        queryFn: async () => {
            const token = await getJwtToken();
            const params = new URLSearchParams(filtros).toString();
            const res = await fetch(`${API_BASE_URL}/v1-informes-flujo-caja?${params}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (!res.ok) throw new Error('Error en Caja');
            return res.json();
        },
        ...CONFIG_REPORTE
    });
};

// Cuando se selecciona una caja mandar el id de esa caja y traer todo el detalle para mapearlo 
export const useGetDetalleCaja = (sesionId) => {
    const { getJwtToken } = useAuth();
    return useQuery({
        queryKey: ['detalle_caja', sesionId],
        queryFn: async () => {
            if (!sesionId) return null;
            const token = await getJwtToken();
            const res = await fetch(`${API_BASE_URL}/v1-informes-flujo-caja-detalle?id=${sesionId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return res.json();
        },
        enabled: !!sesionId,
        ...CONFIG_REPORTE
    });
};

// Este es para traer el detalle de las facturas cuando se abre el historial de caja 
export const useGetProductosDeVenta = (ventaId) => {
    const { getJwtToken } = useAuth();
    return useQuery({
        queryKey: ['productos_venta', ventaId],
        queryFn: async () => {
            if (!ventaId) return null;
            const token = await getJwtToken();
            const res = await fetch(`${API_BASE_URL}/v1-informes-flujo-caja-venta-productos?id=${ventaId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return res.json();
        },
        enabled: !!ventaId,
        ...CONFIG_REPORTE
    });
};